import { AccordionSectionPanel } from "@insite/mobius/AccordionSection";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { TYPOGRAPHY } from "@store/theme/common/design";
import polyfillCss from "@store/theme/common/polyfillCss";
import breakpointValuesMediaQueries from "@store/Framework/Common/Utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";
import getColor from "@insite/mobius/utilities/getColor";

const _buttonLineHeight = TYPOGRAPHY.lineHeight.small;

const _sectionHeaderButtonBaseStyles = () => {
    return polyfillCss`
        padding: 20px 0;
        border: 0;
        font-size: ${TYPOGRAPHY.size.smaller};
        line-height: ${_buttonLineHeight};
        ${props =>
            breakpointValuesMediaQueries(
                props.theme,
                [{ values: [TYPOGRAPHY.size.smaller, null, TYPOGRAPHY.size.base], properties: ["font-size"] }],
                mediaOptions.min,
            )}
    `;
};

export default {
    sectionDefaultProps: {
        headerProps: {
            css: polyfillCss`
                border-top: 1px solid ${getColor("common.border")};

                button {
                    background-color: transparent;
                    ${_sectionHeaderButtonBaseStyles()}

                    &:focus {
                        border: 0;
                        padding: 20px 0;
                        text-decoration: underline;
                    }

                    &:hover {
                        text-decoration: underline;
                    }

                    &[aria-expanded="true"] {
                        background-color: transparent;
                    }
                }

                ${/* sc-selector */ AccordionSectionPanel} + & {
                    button {
                        ${_sectionHeaderButtonBaseStyles()}

                        &:focus {
                            border: 0;
                            padding: 20px 0;
                        }
                    }
                }
            `,
        },
        titleTypographyProps: {
            forwardAs: "span",
            weight: TYPOGRAPHY.weight.bold,
            color: null,
            size: TYPOGRAPHY.size.base,
            lineHeight: "inherit",
        },
        toggleIconProps: {
            color: null,
            css: polyfillCss`
                height: ${_buttonLineHeight}em;
                width: ${_buttonLineHeight}em;
                position: relative;
                top: .05em;

                svg {
                    width: inherit;
                    height: inherit;
                    transform: scale(1.25);
                }
            `,
        },
        collapseIconProps: {
            src: "Minus",
        },
        expandIconProps: {
            src: "Plus",
        },
        panelProps: {
            css: polyfillCss`
                border: 0;
            `,
        },
    },
};
